// extracted by mini-css-extract-plugin
export var accent = "_5g-4";
export var add = "_5g-j";
export var addIcon = "_5g-k";
export var deleteIcon = "_5g-i";
export var disabled = "_5g-9";
export var ellipsis = "_5g-f";
export var error = "_5g-3";
export var form = "_5g-5";
export var hideFocus = "_5g-2";
export var icon = "_5g-7";
export var input = "_5g-e";
export var listItem = "_5g-h";
export var mediumHeight = "_5g-b";
export var noBorder = "_5g-8";
export var noRadius = "_5g-1";
export var shortHeight = "_5g-a";
export var tallHeight = "_5g-c";
export var textInput = "_5g-0";
export var vertical = "_5g-g";
export var veryTallHeight = "_5g-d";
export var widget = "_5g-6";